export default __webpack_public_path__ + "static/media/dashboardicon.deaf45d0.svg";